export const DEFAULT_SAVINGS_CONFIGURATION = {
  numManualSystems: 15,
  numEmailSystems: 0,
  legalSalary: 68.51,
  salesSalary: 62.5,
  engineerSalary: 74.52,
};
